import './header.css';
import { useState, useEffect } from 'react';
import logo from '../images/logo.png';
import faceLogo from '../images/face_logo.png';

function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 180);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className={`header${scrolled ? ' scrolled' : ''}`}>
            <a href="/"><img src={logo} alt="Company Logo" className="logo" /></a>
            <img src={faceLogo} alt="Heather face graphic logo" className="header-face-logo" />
            <nav className={`nav-links${menuOpen ? ' open' : ''}`}>
                <a href="/#work" onClick={closeMenu}>Work</a>
                {/* <a href="/play">Play</a> */}
                <a href="/#about-me" onClick={closeMenu}>About</a>
                <a href="/#connect" onClick={closeMenu}>Contact</a>
            </nav>
            <button
                className={`hamburger${menuOpen ? ' active' : ''}`}
                onClick={() => setMenuOpen(o => !o)}
                aria-label="Toggle navigation"
            >
                <span />
                <span />
                <span />
            </button>
        </header>
    );
}

export default Header;
